import kTest from "./kTest.vue";

export default kTest;
